import { Grid } from 'antd';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';

export const TABLE_SCROLL_Y_LAYOUT_VIEWPORT_BREAKPOINT_PX = 680;

const AppBreakpointContext = createContext(null);

function readViewportDimensions() {
    if (typeof window === 'undefined') return { width: 0, height: 0 };
    return { width: window.innerWidth, height: window.innerHeight };
}

export function BreakpointProvider({ children }) {
    const screens = Grid.useBreakpoint();
    const [viewport, setViewport] = useState(readViewportDimensions);

    useEffect(() => {
        const update = () => setViewport(readViewportDimensions());
        window.addEventListener('resize', update, { passive: true });
        return () => window.removeEventListener('resize', update);
    }, []);

    const value = useMemo(() => {
        const screensResolved = Object.keys(screens).length > 0;
        const isMobile = screensResolved && screens.md === false;
        /** 仅表示视口是否「够高」；与路由白名单合成为 **`useEnableTableScrollYLayout`**（不大于阈值时为 false，对应不写 Table **`scroll.y`**、**`main`** 自然滚动） */
        const viewportAllowsTableScrollYLayout = viewport.height > TABLE_SCROLL_Y_LAYOUT_VIEWPORT_BREAKPOINT_PX;
        return { screens, isMobile, viewport, viewportAllowsTableScrollYLayout };
    }, [screens, viewport]);

    return <AppBreakpointContext.Provider value={value}>{children}</AppBreakpointContext.Provider>;
}

export function useAppBreakpoint() {
    const ctx = useContext(AppBreakpointContext);
    if (ctx == null) {
        throw new Error('useAppBreakpoint 必须在 BreakpointProvider 内使用');
    }
    return ctx;
}
